export default (key) =>
	({
		OVERTIME_BACKEND_URL: 'https://api.itsovertime.com',
		OVERTIME_IMAGES_CDN: 'https://images.itsovertime.com',
		OVERTIME_SHOP_URL: 'https://shop.overtime.tv',
		GOOGLE_MAPS_API_KEY: 'AIzaSyBFZPCDieG-rUkSD3NXb7L9bvqzsMpXdYA',
	})[key];
